import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardAgendaSummaryResolver implements Resolve<string> {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const program = route.paramMap.get('ip').toLocaleUpperCase();
    return of(program);
  }
}
